module.exports = __webpack_public_path__ + "img/logo_1.89837791.png";